import React, {useEffect, useMemo, useState} from 'react';
import {Row, Col, Space, Typography} from 'antd';
import ThemeGrid from "../../components/ThemeGrid";


const themeGridConfig = [
    {
        imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/matrix.jpeg',
        title: "Portfolio X-Ray",
        description: "Analyze your portfolio with our Portfolio X-Ray tool",
        link: '/beta/xray'
    },
        {
        imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/poker.jpeg',
        title: "Volatility Drivers",
        description: "",
            link: '/markets/factors'
    },
        {
        imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/gold-triangle.jpeg',
        title: "Touchpoints",
        description: "Analyze your portfolio with our Portfolio X-Ray tool",
            link: '/beta/touchpoints'
    },
        {
        imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/stadium.jpeg',
        title: "Stadium",
        description: "Analyze your portfolio with our Portfolio X-Ray tool",
            link: '/beta/comparison'
    },
        {
        imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/dogtags.jpeg',
        title: "Advanced",
        description: "",
            link: '/experiments/home'
    },
]


const BetaLauncher = ()=>{
    return (
        <div style={{padding: '2.5%', maxHeight: '90vh', overflow: 'scroll'}} className={'hide-scrollbar'}>
            <ThemeGrid items={themeGridConfig} />
        </div>
    )
}

export default BetaLauncher;